import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Eye, ArrowLeft } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { useOrganization } from '../../contexts/OrganizationContext';
import { Button } from '../ui';

const ImpersonationBanner = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isPlatformAdmin } = useAuth();
  const { isOrgOverridden, orgName, resetOrg } = useOrganization();

  if (!isPlatformAdmin || !isOrgOverridden) return null;
  // Plataforma trata de TODAS las orgs: el aviso de la suplantada ahi contradice a la
  // pantalla (p. ej. "Viendo como MYKLUBB Demo" en los deportes de Aguilas Demo).
  if (pathname.startsWith('/platform')) return null;

  const handleReturn = () => {
    resetOrg();
    navigate('/platform/organizations');
  };

  return (
    <div className="flex items-center justify-between gap-3 border-b bg-amber-50 px-4 py-2 text-amber-900">
      <div className="flex items-center gap-2 text-sm font-medium min-w-0">
        <Eye className="size-4 shrink-0" />
        <span className="truncate">
          Viendo como organizacion: <strong>{orgName}</strong>
        </span>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={handleReturn}
        className="shrink-0 border-amber-300 bg-white hover:bg-amber-100"
      >
        <ArrowLeft className="size-4" />
        <span className="hidden sm:inline">Volver a Plataforma</span>
        <span className="sm:hidden">Volver</span>
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
